<template>
  <div>
    <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card class="box" v-if="tenant == 'zeal' || tenant == 'uwws'">
        <!-- v-if="tenant == 'zeal'" -->
        <v-row dense v-if="leave_balance_report_list != ''">
          <v-col cols="12" sm="12" md="12">
            <v-data-table :headers="headers_balance_report" :items="leave_balance_report_list"
              class="elevation-1 mytable mytable1" :search="search">
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Apply Leave</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-toolbar-title>
            <v-btn class="toolbar" @click="fetchLeaveDashboard('BTN')">Leave Dashboard</v-btn>
            <v-btn title="Leave policy" class="toolbar"
              v-if="org_id == '1' && tenant == 'wws' && usertype == 'Employee'">
              <a href='https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/Leave+policy_WWS.pdf' target="blank"
                class="ml-6">
                <v-icon color="white">mdi-eye</v-icon>
              </a>
            </v-btn>
            <v-btn title="Leave policy" class="toolbar"
              v-if="org_id == '2' && tenant == 'wws' && usertype == 'Employee'">
              <a href='https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/Leave+policy_WWS+Hadapsar.pdf'
                target="blank" class="ml-6">
                <v-icon color="white">mdi-eye</v-icon>
              </a>
            </v-btn>
          </v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Leave Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Leave Type</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="leave_type" return-object
              :items="leave_type_list" @change="setflag()" item-text="type" item-value="id" label="Leave Type" outlined
              persistent-hint hint="Please Select Leave Type" />
          </v-col>
          <v-col cols="12" sm="4" v-if="show_radios">
            <p><v-icon color="error">*</v-icon><b>Is Half Day</b></p>
            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
              <v-radio label="Yes" value="true" color="#0f2027" @change="getval(radios)"></v-radio>
              <v-radio label="No" value="false" color="#0f2027" @change="getval(radios)"></v-radio>
              <!-- @change="getval(radios)" -->
            </v-radio-group>
          </v-col>
          <!-- <v-col cols="12" sm="3">
                    <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                    <v-menu v-model="menu11" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="date_1" label="From Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" persistent-hint hint="YYYY/MM/DD FORMAT(Date Is Inclusive)"></v-text-field>
                </template>
<v-date-picker v-model="date_1" @input="menu11 = false" @change="calculateDays()"></v-date-picker>
</v-menu>
</v-col> -->

          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>From Date</b></p>
            <v-menu ref="menu11" v-model="menu11" :close-on-content-click="false" transition="scale-transition" offset-y
              max-width="290px" min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" dense v-model="leave_from_date" @blur="date = parseDate(leave_from_date)"
                  v-on="on" persistent-hint hint="DD/MM/YYYY FORMAT(Date Is Inclusive)" prepend-icon="event" outlined
                  rounded persistent-hint></v-text-field>
              </template>
              <v-date-picker v-model="from_date" no-title @input="menu11 = false"
                @change="setNoOfDays()"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" v-if="this.radios == 'false'">
            <p><v-icon color="error">*</v-icon><b>To Date</b></p>
            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
              max-width="290px" min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-bind="attrs" dense v-model="leave_to_date" @blur="date = parseDate(leave_to_date)"
                  v-on="on" persistent-hint hint="DD/MM/YYYY FORMAT(Exclusive / Reporting Date)" prepend-icon="event"
                  outlined rounded persistent-hint></v-text-field>
              </template>
              <v-date-picker v-model="to_date" no-title @input="menu2 = false" @change="setNoOfDays()"></v-date-picker>
            </v-menu>
          </v-col>

          <!-- <v-col cols="12" sm="3">
                    <p><v-icon color="error">*</v-icon><b>To Date</b></p>
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="date_2" label="To Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" persistent-hint hint="YYYY/MM/DD FORMAT(Exclusive / Reporting Date)"></v-text-field>
                </template>
                <v-date-picker v-model="date_2" @input="menu2 = false" @change="calculateDays()"></v-date-picker>
            </v-menu>
                </v-col> -->
        </v-row>
        <v-row justify="center" dense>
          <!-- <v-col cols="12" sm="3" v-if="this.leave_type.type == 'HPL'">
            <p><b>No of Days</b></p>
            <v-text-field
              outlined
              dense
              type="number"
              v-model="no_of_days"
            ></v-text-field
          ></v-col> -->
          <!-- <v-col cols="12" sm="3" v-else> -->
          <v-col cols="12" sm="3">
            <p><b>No of Days</b></p>
            <v-text-field outlined dense type="number" v-model="no_of_days" readonly></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <span v-if="this.leave_reasons_list.length <= 0">
              <p><b>Reason</b></p>
              <v-text-field outlined dense type="text" v-model="reason"></v-text-field>
            </span>
            <span v-else>
              <p>
                <b>Leave Reasons</b>
                <v-icon color="error">*</v-icon>
              </p>
              <v-autocomplete color="#0F2027" dense rounded required v-model="leave_reason" :items="leave_reasons_list"
                item-text="value" item-value="id" label="Leave Reasons" outlined />
            </span>
          </v-col>
          <v-col cols="12" sm="3" v-if="tenant != 'wws'">
            <br />
            <v-checkbox v-model="load_adjusted" label="Is Load Adjusted"></v-checkbox>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <p>Half-day and HLWP: From and To Date Must Be <b> Same </b></p>
        </v-row>
        <v-row justify="center" dense>
          <p>CL,ML,LWP etc: From and To Date Must Be <b> Different </b></p>
        </v-row>
      </v-card>
      <v-card class="box" v-if="show_card_1">
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Attachment if any</b>
              <v-icon color="error">*</v-icon>
            </p>
            <v-file-input placeholder="Pick File If Any" prepend-icon="mdi-camera" show-size
              v-model="attachments"></v-file-input>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Alternate Arrangement Person</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" :items="instructor_list"
              item-text="name" item-value="id" label="Instructor" outlined />
          </v-col>
        </v-row>
      </v-card>
      <v-card class="box" v-if="show_card_2">
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Nature Of Work</b></p>
            <v-text-field outlined dense type="text" v-model="nature_of_work"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Place Of Work</b></p>
            <v-text-field outlined dense type="text" v-model="place_of_work"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Contact No</b></p>
            <v-text-field outlined dense type="text" v-model="contact_no"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>From Time</b></p>
            <v-text-field outlined dense type="time" v-model="from_time" />
            <!-- <input type="time" outlined v-model="from_time" /> -->
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>To Time</b></p>
            <v-text-field outlined dense type="time" v-model="to_time" @change="calculateTime()" />
            <!-- <input type="time" outlined v-model="to_time" @change="calculateTime()" /> -->
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>No Of Hours</b></p>
            <v-text-field outlined dense type="text" v-model="no_of_hours"></v-text-field>
          </v-col>
        </v-row>
      </v-card>
      <v-row justify="center" dense>
        <v-btn class="button" @click="apply()"
          v-if="leave_type && (leave_reason || reason) && leave_from_date && leave_to_date"
          :loading="loader">Apply</v-btn>
      </v-row>

      <v-card class="box" v-if="this.transactions != ''">
        <v-data-table class="mytable elevation-1" dense :headers="headers" :items="transactions">
          <template v-slot:top>
            <v-toolbar flat dense class="toolbar">
              <v-toolbar-title>Transactions</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
            <br />
          </template>
          <template v-slot:[`item.leaveapprovalstatus`]="{ item }">
            <v-btn class="ma-2" tile outlined color="success" @click="showdetails(item.id)">
              <v-icon left>mdi-arrow-right-bold-circle-outline</v-icon>
              Details
            </v-btn>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <div v-if="item.leaveapprovalstatus != 'Approved' && item.leaveapprovalstatus != 'Cancelled'">
              <v-avatar size="25" class="edit-avatar">
                <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
              </v-avatar>
            </div>
            <div v-else>--</div>
          </template>
          <template v-slot:[`item.can_cancel`]="{ item }">
            <span v-if="item.can_cancel">
              <v-btn :loading="loader1" outlined rounded @click="cancelLeaveApproval(item)">Cancel</v-btn>
            </span>
            <span v-else> -- </span>
          </template>
        </v-data-table>

        <v-dialog v-model="dialog_edit" max-width="1100px" v-if="dialog_edit == true">
          <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>
                <strong> Edit Leave </strong>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-row justify="center" dense>
                <v-col cols="12" sm="2">
                  <p><b>Leave Type</b></p>
                  <v-text-field outlined dense type="text" v-model="edit_item.leave_type" disabled></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" v-if="edit_item.leave_type === 'CL'">
                  <p><b>Is Half Day</b></p>
                  <v-radio-group v-model="edit_item.radios" mandatory row class="ma-2 no-display">
                    <v-radio label="Yes" value="true" color="#0f2027" @change="getvalediit(edit_item.radios)"></v-radio>
                    <v-radio label="No" value="false" color="#0f2027" @change="getvalediit(edit_item.radios)"></v-radio>
                    <!-- @change="getval(radios)" -->
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="3">
                  <p><b>From Date</b></p>
                  <input type="date" v-model="edit_item.from_date" @change="setNoOfDaysEdit()" />
                </v-col>
                <v-col cols="12" sm="3" v-if="this.edit_item.radios == 'false'">
                  <p><b>To Date</b></p>
                  <input type="date" v-model="edit_item.to_date" @change="setNoOfDaysEdit()" />
                </v-col>
                <v-col cols="12" sm="2">
                  <p><b>Application Date</b></p>
                  <!-- <input type="date" v-model="edit_item.application_date"/> -->
                  <v-text-field outlined dense type="text" v-model="edit_item.application_date" readonly></v-text-field>
                </v-col>
                <v-col cols="12" sm="1">
                  <p><b>No Of Days</b></p>
                  <v-text-field outlined dense type="number" v-model="edit_item.no_of_days" readonly></v-text-field>
                </v-col>
                <v-col cols="12" sm="1" v-if="edit_item.no_of_hours">
                  <p><b>No Of Hours</b></p>
                  <v-text-field outlined dense type="text" v-model="edit_item.no_of_hours"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <p><b>Status</b></p>
                  <v-text-field outlined dense type="text" v-model="edit_item.status"></v-text-field>
                </v-col>

                <v-col cols="12" sm="2" v-if="edit_item.reason">
                  <p><b>Reason</b></p>
                  <v-text-field outlined dense type="text" v-model="edit_item.reason"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" v-if="edit_item.load_adjusted">
                  <p><b>Is Load Adjusted</b></p>
                  <v-checkbox v-model="edit_item.load_adjusted" label="Is Load Adjusted"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" v-if="edit_item.alternate_person">
                  <p><b>Alternate Person</b></p>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="edit_item.alternate_person"
                    :items="instructor_list" item-text="name" item-value="id" label="Instructor" outlined />
                </v-col>
                <v-col cols="12" sm="2" v-if="edit_item.nature_of_work">
                  <p><b>Nature Of Work</b></p>
                  <v-text-field outlined dense type="text" v-model="edit_item.nature_of_work"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" v-if="edit_item.place_of_work">
                  <p><b>Place Of Work</b></p>
                  <v-text-field outlined dense type="text" v-model="edit_item.place_of_work"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <p></p>
                  <v-btn :loading="loader2" class="button" @click="saveUpdate()">Update</v-btn>
                </v-col>
              </v-row>
              <br>
              <v-row justify="center" dense>
                <p>Half-day and HLWP: From and To Date Must Be <b> Same </b></p>
              </v-row>
              <v-row justify="center" dense>
                <p>CL,ML,LWP etc: From and To Date Must Be <b> Different </b></p>
              </v-row>
              <v-card-actions>

                <v-spacer></v-spacer>
                <v-btn class="button" @click="dialog_edit = false">Close</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-row justify="center" dense v-if="emp_approval_details != ''">
          <v-dialog v-model="dialog" persistent max-width="1500">
            <v-card>
              <v-col cols="12" sm="12" md="12">
                <v-card class="box">
                  <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Leave Details</v-toolbar-title>
                  </v-toolbar>
                  <v-col cols="12" sm="12" md="12">
                    <v-simple-table dense class="elevation-1">
                      <thead>
                        <tr>
                          <td>From Date</td>
                          <td>To Date</td>
                          <td>Application Date</td>
                          <td>Number Of Days</td>
                          <td>Number Of Hours</td>
                          <td>Reason</td>
                          <td>Is Load Adjustment Done</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ emp_approval_details[0].fromdate }}</td>
                          <td>{{ emp_approval_details[0].todate }}</td>
                          <td>
                            {{ emp_approval_details[0].application_date }}
                          </td>
                          <td>{{ emp_approval_details[0].numberofdays }}</td>
                          <td>{{ emp_approval_details[0].number_of_hours }}</td>
                          <td>{{ emp_approval_details[0].reason }}</td>
                          <td>
                            <span v-if="
                              emp_approval_details[0].is_load_adjustment_done
                            ">YES</span>
                            <span v-else>NO</span>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-simple-table dense class="elevation-1">
                      <thead>
                        <tr>
                          <td>Alternate Arrangement Person Name</td>
                          <td>Alternate Arrangement Person Contact Number</td>
                          <td>Nature Of Work</td>
                          <td>Place Of Work</td>
                          <td>Email</td>
                          <td>Mobile</td>
                          <td>Medical Certificate / Other Document</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{
                            emp_approval_details[0]
                            .alternate_arragement_person_name
                            }}
                          </td>
                          <td>
                            {{
                            emp_approval_details[0]
                            .alternate_arragement_person_no
                            }}
                          </td>
                          <td>{{ emp_approval_details[0].nature_of_work }}</td>
                          <td>{{ emp_approval_details[0].place_of_work }}</td>
                          <td>{{ emp_approval_details[0].email }}</td>
                          <td>
                            {{ emp_approval_details[0].contact_phone_number }}
                          </td>
                          <td>
                            <span v-if="
                              emp_approval_details[0].certificate_file_name !=
                              'NA'
                            ">
                              <!-- <a class="p-2" :href="aws_path+emp_approval_details[0].filepath+emp_approval_details[0].filename" target="blank"> -->
                              <a class="p-2" :href="aws_path +
                                emp_approval_details[0].certificate_file_name
                                " target="blank">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                      <v-icon color="black">mdi-eye</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>
                                    View Certificate / Other Document File!!!
                                  </span>
                                </v-tooltip>
                              </a>
                            </span>
                            <span v-else>
                              {{
                              emp_approval_details[0].certificate_file_name
                              }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-data-table :headers="headers1" :items="emp_approval_details[0].emp_approval"
                      class="mytable elevation-1" dense>
                    </v-data-table>
                  </v-col>
                </v-card>
              </v-col>
              <v-row justify="center" dense>
                <v-btn class="button" @click="dialog = false">Close</v-btn>
              </v-row>
            </v-card>
          </v-dialog>
        </v-row>
      </v-card>
    </v-container>
    <v-dialog v-model="show_leave_table" max-width="1000px">
      <v-card class="card-container">
        <v-card class="box">
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Leaves Details </strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row dense>
              <v-data-table :headers="headers_balance_report" :items="leave_balance_report_list"
                class="elevation-1 box mytable" :search="search">
              </v-data-table>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="button" @click="show_leave_table = false">Close</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
  <!-- /. root div -->
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
   components: {
    Breadcrumbs,
  },
  data: () => ({
    radios: null,
    show_radios: false,
    extraBreadcrumbItems: [


    ],
    breadcrumbClass: "breadcrumb-style1",
    leave_from_date: "",
    from_date: new Date().toISOString().substr(0, 10),
    leave_to_date: "",
    to_date: new Date().toISOString().substr(0, 10),
    usertype: null,
    leave_reasons_list: [],
    leave_reason: "",
    search: "",
    leave_balance_report_list: [],
    loader: false,
    loader1: false,
    loader2: false,
    snackbar_msg: "",
    show_leave_table: false,
    leave_table: "",
    color: "",
    snackbar: false,
    dialog: false,
    title: "",
    description: "",
    leaves_list: [],
    leave_type_list: [],
    leave_type: "",
    no_of_days: 0,
    reason: "",
    load_adjusted: false,
    org_id: null,
    show_card_1: false,
    show_card_2: false,
    attachments: null,
    instructor_list: [],
    instructor: "",
    nature_of_work: "",
    place_of_work: "",
    contact_no: "",
    from_time: "",
    to_time: "",
    no_of_hours: "",
    transactions: [],
    leave_balance_data: [],
    dialog_edit: false,
    emp_approval_details: [],
    aws_path: "",
    ay_list: [],
    ay: "",
    leave_approval_status_list: [],
    date_1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    modal_1: false,
    date_2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    modal_2: false,
    menu: false,
    menu2: false,
    menu1: false,
    menu11: false,
    dialog: false,

    menu3: false,
    headers_balance_report: [
      // {
      //   text: 'Employee Name',
      //   align: 'left',
      //   sortable: true,
      //   value: 'instructor',
      // },
      {
        text: "Leave Type",
        align: "left",
        sortable: true,
        value: "leavetype",
      },
      {
        text: "Leave Academic Year",
        align: "left",
        sortable: false,
        value: "leaveacademicyear",
      },
      {
        text: "Total Leaves(Days)",
        align: "left",
        sortable: false,
        value: "totalleaves",
      },
      {
        text: "Leaves In-Process(Days)",
        align: "left",
        sortable: false,
        value: "leavesinprogress",
      },
      {
        text: "Total Avalied Leaves(Days)",
        align: "left",
        sortable: false,
        value: "availedleaves",
      },
      // {
      //   text: 'Total Rejected',
      //   align: 'left',
      //   sortable: false,
      //   value: 'rejected',
      // },
      {
        text: "Balance Leaves(Days)",
        align: "left",
        sortable: false,
        value: "balanceleaves",
      },
    ],
    headers1: [
      {
        text: "Sr. No",
        value: "srno",
        sortable: false,
      },
      {
        text: "Authority",
        value: "authority",
        sortable: false,
      },
      {
        text: "Authority Name",
        value: "authority_name",
        sortable: false,
      },
      {
        text: "Date Of Application",
        value: "application_push_date",
        sortable: false,
      },
      {
        text: "Date Of Approval",
        value: "application_action_date",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        sortable: false,
      },
      {
        text: "Remark",
        value: "remark",
        sortable: false,
      },
    ],
    headers: [
      {
        text: "Sr No",
        value: "count",
      },
      {
        text: "Leave Type",
        value: "leavetype",
      },
      {
        text: "Application Date",
        value: "application_date",
      },
      {
        text: "From Date",
        value: "fromdate",
      },
      {
        text: "To Date",
        value: "todate",
      },
      {
        text: "Days",
        value: "numberofdays",
      },
      {
        text: "Hours",
        value: "number_of_hours",
      },
      {
        text: "Reason",
        value: "reason",
      },
      {
        text: "Status",
        value: "leaveApprovalStatus",
      },
      {
        text: "Status",
        value: "leaveapprovalstatus",
      },
      {
        text: "Edit",
        value: "edit",
      },
      {
        text: "Cancel",
        value: "can_cancel",
      },
      //  { text: "Pending From", value: "leavetype" },
    ],
    edit_item: {
      nature_of_work: "",
      from_date: "",
      to_date: "",
      application_date: "",
      no_of_days: "",
      no_of_hours: "",
      reason: "",
      load_adjusted: "",
      alternate_person: "",
      place_of_work: "",
      email: "",
      mobile: "",
      attachments: null,
      status: "",
      id: "",
      tenant: null,
      leavetype_id: "",
      radios: null,
    },
  }),
  methods: {
    getval(item) {
      // alert(item)
      if (this.radios == 'true' || this.radios == true) {
        this.no_of_days = 0;
      } else {
        this.no_of_days = 0.5
      }
    },
    getvalediit(item) {
      // alert(item)
      if (this.edit_item.radios == 'true' || this.edit_item.radios == true) {
        this.edit_item.no_of_days = 0;
      } else {
        this.edit_item.no_of_days = 0.5
      }
    },
    cancelLeaveApproval(item) {
      this.loader1 = true;
      const formData = {
        leave_transaction_id: item.id,
      };
      axios
        .post("/LeaveManagement/cancelSelfLeaveApproval", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            //  this.transactions=res.data.transactions,
            this.loader1 = false;
            this.showSnackbar("#4caf50", "Leave Cancelled Successfully...!");
            this.onLoad();
          } else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.loader1 = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
        })
        .finally(() => {
          this.loader1 = false;
          this.fetch();
        });
    },
    saveUpdate() {
      if (this.edit_item.leave_type == "HLWP") {
        if (this.edit_item.from_date != this.edit_item.to_date) {
          this.showSnackbar(
            "#b71c1c",
            "Please Select From Date And To Date Same ..."
          );
          return;
        }
      }
      if (this.edit_item.no_of_days <= 0) {
        this.showSnackbar(
          "#b71c1c",
          "Number Of Days Should Not Be Negative Or Zero.."
        );
        return;
      }
      axios
        .post("/LeaveManagement/saveUpdateLeave", this.edit_item)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.showSnackbar("#4caf50", "Leave Updated Successfully...!");
            this.loader2 = false;
            this.dialog_edit = false;
            this.clearData();
            this.onLoad();
          } else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.loader2 = false;
          }
          else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.loader2 = false;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader2 = false;
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showdetails(emp_leave_transaction_id) {
      this.dialog = true;
      const formData = {
        emp_leave_transaction_id: emp_leave_transaction_id,
      };
      axios
        .post("/LeaveManagement/getEmployeeLeaveDetails", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.emp_approval_details = res.data.emp_transaction_list;
            this.aws_path = res.data.aws_path;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
        })
        .finally(() => { });
    },
    setInitialValues() {

      // Assuming edit_item contains the existing data
      this.edit_item.radios = (this.edit_item.no_of_days === 0.5) ? 'true' : 'false';
    },
    editItem(item) {
      // alert("item::"+item.id)
      this.dialog_edit = true;
      this.edit_item.id = item.id;
      this.edit_item.nature_of_work = item.nature_of_work;
      this.edit_item.from_date = item.fromdate_edit;
      this.edit_item.to_date = item.todate_edit;
      this.edit_item.application_date = item.application_date_edit;
      this.edit_item.no_of_days = item.numberofdays;
      this.edit_item.no_of_hours = item.number_of_hours;
      this.edit_item.reason = item.reason;
      this.edit_item.load_adjusted = item.is_load_adjustment_done;
      this.edit_item.alternate_person = item.alternate_arragement_person_id;
      this.edit_item.nature_of_work = item.nature_of_work;
      this.edit_item.place_of_work = item.place_of_work;
      this.edit_item.status = item.leaveapprovalstatus;
      this.edit_item.leavetype_id = item.leavetype_id;
      this.edit_item.leave_type = item.leavetype;
      this.setInitialValues();
    },
    clearData() {
      (this.leave_type = ""),
        (this.reason = ""),
        (this.load_adjusted = false),
        (this.show_card_1 = false),
        (this.show_card_2 = false),
        (this.attachments = null),
        (this.instructor = ""),
        (this.nature_of_work = ""),
        (this.place_of_work = ""),
        (this.contact_no = ""),
        (this.from_time = ""),
        (this.to_time = ""),
        (this.no_of_hours = ""),
        (this.no_of_days = 0);
      this.radios = null, this.show_radios = false
    },
    setflag() {
      this.radios = 'false'
      this.no_of_days = 0;
      this.show_radios = false;
      this.show_card_1 = false;
      this.show_card_2 = false;
      if (this.leave_type.is_certificate_applicable == true) {
        this.show_card_1 = true;
        this.show_card_2 = false;
      }
      if (this.leave_type.is_for_official_duty == true) {
        this.show_card_2 = true;
        this.show_card_1 = true;
      }
      if (this.leave_type.type == "HPL" || this.leave_type.type == "HLWP") {
        this.setNoOfDays();
      }
      //    if(this.leave_type.type == "OD"){
      //        this.show_card_2=true
      //        this.show_card_1=true
      //    }
      //     else if(this.leave_type.type == "CL"){
      //        this.show_card_2=false
      //        this.show_card_1=false
      //    }
      //     else if(this.leave_type.type == "ML" || this.leave_type.type == "HPL"){
      //        this.show_card_1=true
      //         this.show_card_2=false
      //    }

      //if (this.leave_type.type == "CL") {
      if (this.leave_type.is_half_day_applicable) {
        this.show_radios = true
        this.radios = 'false'
        this.no_of_days = 0
      }
    },
    setNoOfDays() {
      if (this.radios == 'true' || this.radios == true) {
        return
      }
      this.no_of_days = 0;
      this.loader = true;
      const formData = {
        date_1: this.from_date,
        date_2: this.to_date,
        leave_type: this.leave_type.id,
      };
      axios
        .post("/LeaveManagement/setNoOfDays", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.loader = false;
            this.no_of_days = res.data.noOfDaysBetween;
          } else if (res.data.flag == "No") {
            this.no_of_days = res.data.noOfDaysBetween;
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
          else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.loader = false;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    setNoOfDaysEdit() {
      this.no_of_days = 0;
      this.loader = true;
      const formData = {
        date_1: this.edit_item.from_date,
        date_2: this.edit_item.to_date,
        leave_type: this.edit_item.leavetype_id,
      };
      axios
        .post("/LeaveManagement/setNoOfDays", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.loader = false;
            this.edit_item.no_of_days = res.data.noOfDaysBetween;
          } else if (res.data.flag == "No") {
            this.no_of_days = res.data.noOfDaysBetween;
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
          else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.loader = false;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    calculateTime() {
      this.loader = true;
      const formData = {
        from_time: this.from_time,
        to_time: this.to_time,
      };
      axios
        .post("/LeaveManagement/calculateTime", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.loader = false;
            this.no_of_hours = res.data.differenceInHours;
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.loader = false;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    calculateDays() {
      this.loader = true;
      const formData = {
        date_1: this.from_date,
        date_2: this.to_date,
      };
      axios
        .post("/LeaveManagement/calculateDays", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.loader = false;
            this.no_of_days = res.data.noOfDaysBetween;
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.loader = false;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    apply() {
      if (this.ay == "" || this.ay == null) {
        this.showSnackbar("#b71c1c", "Please Select Academic Year...");
        return;
      }
      if (this.leave_type == "" || this.leave_type == null) {
        this.showSnackbar("#b71c1c", "Please Select Leave Type...");
        return;
      }
      if (this.leave_type.type == "HLWP") {
        if (this.leave_from_date != this.leave_to_date) {
          this.showSnackbar(
            "#b71c1c",
            "Please Select From Date And To Date Same ..."
          );
          return;
        }
      }
      if (this.no_of_days == 0) {
        this.showSnackbar(
          "#b71c1c",
          "Please Enter Number Of Days More Than Zero..."
        );
        return;
      }
      if (this.no_of_days < 0) {
        this.showSnackbar(
          "#b71c1c",
          "Number Of Days Should Not Be Negative.."
        );
        return;
      }
      if (this.no_of_hours < 0) {
        this.showSnackbar(
          "#b71c1c",
          "Number Of Hours Should Not Be Negative.."
        );
        return;
      }
      if (this.leave_type.is_certificate_applicable == true) {
        if (this.attachments == null || this.attachments == "") {
          this.showSnackbar("#b71c1c", "Please Attach Certificate...");
          return;
        }
      }
      this.loader = true;
      let formData = new FormData();
      formData.append("ay", this.ay);
      formData.append("leave_type", this.leave_type.id);
      // formData.append("from_date", this.date_1);
      formData.append("from_date", this.leave_from_date);
      //   formData.append("to_date", this.date_2);
      formData.append("to_date", this.leave_to_date);
      formData.append("no_of_days", this.no_of_days);
      formData.append("is_half_day", this.radios);
      formData.append("reason", this.reason);
      formData.append("leave_reason", this.leave_reason);
      formData.append("load_adjusted", this.load_adjusted);
      formData.append("attachments", this.attachments);
      formData.append("instructor", this.instructor);
      formData.append("nature_of_work", this.nature_of_work);
      formData.append("place_of_work", this.place_of_work);
      formData.append("contact_no", this.contact_no);
      formData.append("from_time", this.from_time);
      formData.append("to_time", this.to_time);
      formData.append("no_of_hours", this.no_of_hours);
      axios
        .post("/LeaveManagement/saveApplyLeave", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            if (res.data.warning) {
                this.showSnackbar("#ff9800", res.data.warning); // Show warning in orange
              }
            this.showSnackbar("#4caf50", "Leave Applied Successfully...!");
            this.loader = false;
            this.clearData();
            this.onLoad();
          } else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.loader = false;
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.loader = false;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    fetchLeaveDashboard(type) {
      axios
        .get("/LeaveManagement/fetchLeaveDashboard")
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.leave_balance_report_list =
              res.data.employee_leave_transaction_details_list;
            if (type == "BTN") {
              this.show_leave_table = true;
            } else {
              this.show_leave_table = false;
            }
          } else {
            this.showSnackbar("#b71c1c", "Wrong information");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
        })
        .finally(() => {
          // 'use strict';
        });
    },

    onLoad() {
      axios
        .get("/LeaveManagement/applyLeave")
        .then((res) => {
          if (res.data.flag == "Yes") {
            (this.ay_list = res.data.ay_list),
              (this.leave_type_list = res.data.leave_type_list),
              (this.ay = res.data.curreny_ay),
              (this.instructor_list = res.data.instructor_list),
              (this.transactions = res.data.transactions),
              (this.leave_balance_data =
                res.data.employee_leave_transaction_details_list);
            this.leave_approval_status_list =
              res.data.leave_approval_status_list;
            // this.leave_balance_report_list = res.data.employee_leave_transaction_details_list;
            this.leave_reasons_list = res.data.leave_reasons_list;
          } else {
            this.showSnackbar("#b71c1c", "Wrong information");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
        })
        .finally(() => {
          // 'use strict';
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
    this.leave_from_date = this.formatDate(this.from_date);
    this.leave_to_date = this.formatDate(this.to_date);
    this.fetchLeaveDashboard("ONLOAD");
    this.radios = 'false'
    this.org_id = localStorage.getItem("EPS-org-id")
    this.usertype = localStorage.getItem("EPS-ut");
    // this.radios=false
  },
  watch: {
    from_date(val) {
      this.leave_from_date = this.formatDate(this.from_date);
    },
    to_date(val) {
      this.leave_to_date = this.formatDate(this.to_date);
    },
  },
  created() {
    this.tenant = localStorage.getItem("EPS-tenant");
  },
};
</script>

<style scoped>
input[type="text"] {
  width: 100%;
  display: inline-block;
  border: 1px solid black;
  border-radius: 4px;
  box-sizing: border-box;
}

.select {
  width: 100%;
  display: inline-block;
  border: 1px solid black;
  border-radius: 4px;
  box-sizing: border-box;
}

input[type="date"] {
  width: 50%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}

tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}

tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}

td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}

@media (min-width: 320px) {

  td,
  th {
    display: table-cell !important;
    font-size: small;
  }

  td+td,
  th+th {
    width: auto;
    font-size: small;
  }
}

v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}

.table-head-background {
  background-color: #fcc96f;
  color: #fff;
  font-weight: 700;
}

.tc-title {
  background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
  color: #fff;
  font-weight: 700;
  margin: 0px !important;
  padding: 0px !important;
}

.text-left {
  font-size: 14px;
  font-weight: bold;
}

.text {
  color: blue;
  font-weight: 600;
  font-size: 14px;
}

.card-container {
  overflow-x: hidden;
  overflow: hidden;
}

/* .mytable1 {
  padding: 5px !important;
} */
.mytable1>>>td {
  font-size: 15px;
  /* background-color: red; */
  /* padding: 3px; */
  height: 6px;
}
</style>
